var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "mb5" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.queryForm.params,
                "label-position": "top",
                "label-width": "auto",
                size: "small",
              },
            },
            [
              _c(
                "div",
                { staticClass: "searchContainer" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "CNPJ", prop: "cnpj" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "GlobalSetObj.pleaseInput"
                                  ),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.queryForm.params.cnpj,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryForm.params, "cnpj", $$v)
                                  },
                                  expression: "queryForm.params.cnpj",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("basicData.CustomerName"),
                                prop: "customerId",
                              },
                            },
                            [
                              _c("QueryCustomerCmp", {
                                attrs: { val: _vm.queryForm.params.customerId },
                                on: {
                                  change: function (val) {
                                    return (_vm.queryForm.params.customerId =
                                      val)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("basicData.TransactionDate"),
                              },
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "default-time": ["00:00:00", "23:59:59"],
                                  "end-placeholder": _vm.$t(
                                    "GlobalSetObj.endDate"
                                  ),
                                  "start-placeholder": _vm.$t(
                                    "GlobalSetObj.startDate"
                                  ),
                                  type: "datetimerange",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                },
                                model: {
                                  value: _vm.time,
                                  callback: function ($$v) {
                                    _vm.time = $$v
                                  },
                                  expression: "time",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("basicData.TransactionType"),
                                prop: "tradeType",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.queryForm.params.tradeType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "tradeType",
                                        $$v
                                      )
                                    },
                                    expression: "queryForm.params.tradeType",
                                  },
                                },
                                _vm._l(_vm.TRANSACTION_TYPE, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("basicData.TransactionStatus"),
                                prop: "status",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.queryForm.params.status,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "status",
                                        $$v
                                      )
                                    },
                                    expression: "queryForm.params.status",
                                  },
                                },
                                _vm._l(_vm.TRANSACTION_STATUS, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("basicData.SerialNumber"),
                                prop: "rechargeNo",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "GlobalSetObj.pleaseInput"
                                  ),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.queryForm.params.rechargeNo,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm.params,
                                      "rechargeNo",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.params.rechargeNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "basicData.FundStatusVerification"
                                ),
                                prop: "fundCheckStatus",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.queryForm.params.fundCheckStatus,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "fundCheckStatus",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "queryForm.params.fundCheckStatus",
                                  },
                                },
                                _vm._l(
                                  _vm.FUNDSTATUSVERIFICATION,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: " " } },
                            [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "permit",
                                      rawName: "v-permit:remove",
                                      value:
                                        "btn:finance:fundManagement:customerRechargeDetails:page",
                                      expression:
                                        "'btn:finance:fundManagement:customerRechargeDetails:page'",
                                      arg: "remove",
                                    },
                                  ],
                                  attrs: {
                                    icon: "el-icon-search",
                                    size: "small",
                                    type: "primary",
                                  },
                                  on: { click: _vm.searchResources },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("operationCenter.Procurar")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    icon: "el-icon-refresh",
                                    size: "small",
                                  },
                                  on: { click: _vm.onReset },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("basicData.reset")) + " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "div",
            { staticClass: "feet-r mb10" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.openRecharge },
                },
                [_vm._v(_vm._s(_vm.$t("basicData.recharge")) + " ")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "feet-btn",
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.openBatchRecharge },
                },
                [_vm._v(_vm._s(_vm.$t("basicData.BatchImportRecharge")) + " ")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "feet-btn",
                  attrs: { size: "small" },
                  on: { click: _vm.onExport },
                },
                [_vm._v(_vm._s(_vm.$t("receivablePayable.Export")) + " ")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              key: _vm.tableKey,
              ref: "table",
              staticClass: "table-height",
              attrs: {
                data: _vm.tableData,
                height: _vm.tableHeightRow.height,
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("basicData.serialNumber"),
                  align: "center",
                  width: "60px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              (_vm.queryForm.pageNumber - 1) *
                                _vm.queryForm.pageSize +
                                scope.$index +
                                1
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._l(_vm.columns, function (item, ind) {
                return _c("el-table-column", {
                  key: ind,
                  attrs: {
                    align: item.align,
                    label: item.label,
                    "min-width": item.width,
                    prop: item.prop,
                    "show-overflow-tooltip": true,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            item.prop === "receiptUrl"
                              ? _c(
                                  "div",
                                  [
                                    _vm._l(
                                      _vm.getReceiptFiles(scope.row.receiptUrl),
                                      function (file, fIdx) {
                                        return _c(
                                          "div",
                                          {
                                            key: fIdx,
                                            staticClass: "receipt-link",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleDownload(file)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(file.name) + " "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    !_vm.getReceiptFiles(scope.row.receiptUrl)
                                      .length
                                      ? _c("span", [_vm._v("--")])
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _c("span", [
                                  _vm._v(_vm._s(scope.row[item.prop])),
                                ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("basicData.operate"),
                  align: "center",
                  fixed: "right",
                  width: "160",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !scope.row.fundCheckStatus
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-popconfirm",
                                  {
                                    attrs: {
                                      title: _vm.$t(
                                        "basicData.ConfirmVerification"
                                      ),
                                    },
                                    on: {
                                      confirm: function ($event) {
                                        return _vm.updateStatus(scope.row, 1)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "template",
                                      { slot: "reference" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "permit",
                                                rawName: "v-permit:remove",
                                                value:
                                                  "btn:finance:fundManagement:customerRechargeDetails:verification",
                                                expression:
                                                  "\n                    'btn:finance:fundManagement:customerRechargeDetails:verification'\n                  ",
                                                arg: "remove",
                                              },
                                            ],
                                            attrs: {
                                              size: "mini",
                                              type: "warning",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "basicData.Verification"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  2
                                ),
                                _c(
                                  "el-popconfirm",
                                  {
                                    attrs: {
                                      title: _vm.$t(
                                        "basicData.MarkAsException"
                                      ),
                                    },
                                    on: {
                                      confirm: function ($event) {
                                        return _vm.updateStatus(scope.row, 2)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "template",
                                      { slot: "reference" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "permit",
                                                rawName: "v-permit:remove",
                                                value:
                                                  "btn:finance:fundManagement:customerRechargeDetails:exception",
                                                expression:
                                                  "'btn:finance:fundManagement:customerRechargeDetails:exception'",
                                                arg: "remove",
                                              },
                                            ],
                                            staticStyle: {
                                              "margin-left": "10px",
                                            },
                                            attrs: {
                                              size: "mini",
                                              type: "danger",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("basicData.Exception")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  2
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  "current-page": _vm.queryForm.pageNumber,
                  "page-size": _vm.queryForm.pageSize,
                  "page-sizes": [10, 20, 50, 100, 500],
                  total: _vm.total,
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "current-change": _vm.getCurrentPage,
                  "size-change": _vm.getSizePage,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            "before-close": _vm.handleClose,
            title: _vm.$t("basicData.ManualRecharge"),
            visible: _vm.rechargeVisible,
            "wrapper-closable": false,
            direction: "ltr",
            size: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.rechargeVisible = $event
            },
          },
        },
        [
          _c("RechargeForm", {
            attrs: { visible: _vm.rechargeVisible },
            on: { close: _vm.handleClose },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("basicData.BatchImportRecharge"),
            visible: _vm.batchRechargeVisible,
            top: "6vh",
            width: "45%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.batchRechargeVisible = $event
            },
          },
        },
        [
          _c("BatchRechargeForm", {
            attrs: { visible: _vm.batchRechargeVisible },
            on: { close: _vm.handleClose, submit: _vm.handleSubmit },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }